import * as React from "react";
import { useParams } from "react-router-dom";
import { useGetCloudAccountQuery } from "../../store/api/cloudaccountApi";
import { CloudAccountDetailForm } from "./detailForm";
import { Loader } from "../../components/layout/loader";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";

type RouteParams = "org" | "cloudaccount";
export const CloudAccountDetailInitializer: React.FC = () => {
  const { org: orgName, cloudaccount: cloudAccountName } = useParams<RouteParams>();

  const selfLink = `/org/${orgName}/cloudaccount/${cloudAccountName}`;

  const { data: cloudAccount, isLoading, isFetching, isError, error, refetch } = useGetCloudAccountQuery(selfLink, {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
  });

  if (!cloudAccount && isLoading) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="cloudaccount" />;
  }

  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !cloudAccount) {
    return <IncorrectItem kind="cloudaccount" canCreate={true} />;
  }

  return <CloudAccountDetailForm cloudAccount={cloudAccount} />;
};
